module.exports = __webpack_public_path__ + "static/media/url.7869b7f4.svg";